import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=5acb7952"
import script from "./DownloadApp.vue?vue&type=script&lang=ts"
export * from "./DownloadApp.vue?vue&type=script&lang=ts"
import style0 from "./DownloadApp.vue?vue&type=style&index=0&id=5acb7952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports